import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Linkedin, Award } from "lucide-react";
import { siteContent } from "../content/siteContent";
import { useToast } from "../hooks/use-toast";
import logo from "../assets/squadrcm_logo.png"; // Change the filename/extension if yours is .svg or .jpg


const Footer = () => {
  const [email, setEmail] = useState("");
  const { toast } = useToast();

  const onSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    toast({
      title: "Subscribed!",
      description: `Thanks for subscribing with ${email}.`,
    });
    setEmail("");
  };

  return (
    <footer className="bg-[#97a897] text-white">
      {/* Newsletter */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <h3 className="text-2xl font-bold">Subscribe To Our Newsletter</h3>
          <form onSubmit={onSubscribe} className="flex w-full md:w-[520px] bg-white rounded-md overflow-hidden shadow-lg">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your Email Address...."
              className="flex-1 px-5 py-3 text-slate-700 outline-none text-sm"
            />
            <button
              type="submit"
              className="bg-[#22b8db] hover:bg-[#1ea3c2] px-6 font-semibold text-white transition-colors"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>

      {/* Main */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2 mb-5">
            <div className="w-40 h-10 rounded-full bg-transparent flex items-center justify-center">
              <img 
        src={logo} 
        alt="SquadRCM Logo" 
        className="w-full h-auto" 
      />
            </div>
            <div className="text-lg font-extrabold">
              {siteContent.brand.logoText}
              {/*  <span className="text-[#22b8db]">{siteContent.brand.logoAccent}</span>*/}
            </div>
            <br></br>
            <div className="text-[10px] text-slate-500 tracking-widest uppercase">
                Private(OPC) Ltd
              </div>
          </div>
          <p className="text-white/70 text-sm leading-relaxed mb-5">
            {siteContent.footer.about}
          </p>
          <div className="flex gap-3 mb-6">
            {[
              { Icon: Facebook, href: siteContent.contact.socials.facebook },
              { Icon: Twitter, href: siteContent.contact.socials.twitter },
              { Icon: Instagram, href: siteContent.contact.socials.instagram },
              { Icon: Linkedin, href: siteContent.contact.socials.linkedin },
            ].map(({ Icon, href }, i) => (
              <a
                key={i}
                href={href}
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#22b8db] flex items-center justify-center transition-colors"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
          <div className="flex items-center gap-2 text-white/70 text-xs">
            <Award className="w-4 h-4 text-[#22b8db]" />
            {siteContent.footer.certifications}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-lg font-bold mb-5">Quick Link</h4>
          <ul className="space-y-3 text-sm">
            {siteContent.footer.quickLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-white/70 hover:text-[#22b8db] transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Solutions A */}
        <div>
          <h4 className="text-lg font-bold mb-5">Solutions</h4>
          <ul className="space-y-3 text-sm">
            {siteContent.footer.solutionsColA.map((s, i) => (
              <li key={i} className="text-white/70 hover:text-[#22b8db] transition-colors cursor-pointer">
                {s}
              </li>
            ))}
          </ul>
        </div>

        {/* Solutions B */}
        <div>
          <h4 className="text-lg font-bold mb-5 opacity-0 select-none">Solutions</h4>
          <ul className="space-y-3 text-sm">
            {siteContent.footer.solutionsColB.map((s, i) => (
              <li key={i} className="text-white/70 hover:text-[#2596be] transition-colors cursor-pointer">
                {s}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 text-sm text-white/70 tracking-wide">
          {siteContent.footer.copyright}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
